export const SHOWN_TYPE_OFFENE = "OFFENE";
export const SHOWN_TYPE_ERLEDIGTE = "ERLEDIGTE";

export const COLORS = ["#ffffff", "#FFF9C4", "#BBDEFB", "#FFCCBC", "#ECEFF1", "#B2DFDB", "#F8BBD0", "#B2EBF2", "#FFF9C4", 
"#FF9E80","#A7FFEB","#ff8a80","#ECEFF1","#D7CCC8","#FFD180","#FF80AB","#8C9EFF","#AEEA00","#BDBDBD","#FAFAFA","#FFF9C4",
"#BBDEFB","#FFCCBC","#ECEFF1","#B2DFDB","#F8BBD0","#B2EBF2","#FFF9C4","#FF9E80","#A7FFEB","#ff8a80","#ECEFF1","#D7CCC8","#FFD180",
"#FF80AB","#8C9EFF","#AEEA00","#BDBDBD","#FAFAFA"];